<template>
  <div class="flex column xs-font" style="height: 100%">
    <div v-if="salesin" class>
      <div v-if="$route.params.orderId">
        <div :key="orderKey" v-for="(order, orderKey) in $store.state.sales">
          <div
            class="container"
            v-if="$route.params.orderId ? $route.params.orderId === orderKey : !$route.params.orderId"
          >
            <div class="sub-container flex around align-center wrap">
              <h4>Order ID: {{orderKey}}</h4>
              <h4>Complete: {{order.complete}}</h4>
              <h4>Total: {{order.total}}</h4>
              <h4>Paid: {{order.paid}}</h4>
              <code
                class="xs-font"
              >Order placed on {{new Date(order.timestamp).toLocaleDateString('en-US', {})}}</code>
            </div>
            <div
              :key="itemKey"
              v-for="(item, itemKey) in order.items"
              class="flex wrap between sm-font"
            >
              <div class="p8 flex between wrap align-center flexw">
                <router-link :to="`/i/${item.type}/${item.iitemid}`" class="r8 flex wrap">
                  <b class="r4">
                    <i :class="$store.state.icons[item.type]" class="r4"></i>
                    {{item.itemTitle}}
                  </b>
                  <code>[{{item.iitemid}}]</code>
                </router-link>
                <div class="r8">
                  <label class="r4">Status:</label>
                  <select 
                    @change="updateOrder(orderKey, item)"
                    v-model="item.status"
                    name="item-status"
                    id="item-status"
                  >
                    <option
                      :key="statusKey"
                      v-for="(status, statusKey) in ['new-order', 'processing', 'shipped', 'delivered', 'order-error']"
                      :value="status"
                    >{{status}}</option>
                  </select>
                </div>
                <div class="flex wrap">
                  <code class="r8">
                    <b class="r4">Quantity:</b>
                    {{item.qty}}
                  </code>
                  <code class="r8">
                    <b class="r4">Cost:</b>
                    <i
                      :class="`fa-xs fas fa-${item.purchase.currency.toLowerCase() === 'usd' ? 'dollar-sign' : ''}`"
                    ></i>
                    {{item.purchase.cost}}
                  </code>
                  <code class="r8">
                    <b class="r4">S&H:</b>
                    <i
                      :class="`fa-xs fas fa-${item.purchase.currency.toLowerCase() === 'usd' ? 'dollar-sign' : ''}`"
                    ></i>
                    {{item.purchase['shipping and handling']}}
                  </code>
                  <div class="r8">
                    <b class="r4">Total:</b>
                    <i
                      :class="`fa-xs fas fa-${item.purchase.currency.toLowerCase() === 'usd' ? 'dollar-sign' : ''}`"
                    ></i>
                    {{(item.purchase.cost * item.qty) + item.purchase['shipping and handling']}}
                  </div>
                </div>
              </div>
              <div class="r8 flex wrap align-center">
                <div class="sub-container flex wrap align-center">
                  <b class="r4">Bought by:</b>
                  <user :userid="item.buyer"></user>
                </div>

                <div class="sub-container flex align-center flexx wrap">
                  <span class="r8 flex align-center">
                    <b class="r4">Ship to:</b>
                    <span v-if="item.shipping">{{item.shipping.name}}</span>
                  </span>
                  <span
                    :key="addyKey"
                    v-for="(addy, addyKey) in item.shipping"
                    class="flex align-center"
                  >
                    <code v-if="item.shipping && addyKey !== 'name'" class="r8 flex align-center">
                      <b class="r4">{{addyKey}}:</b>
                      {{addy}}
                    </code>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <table class="container" v-else>
        <thead class="sub-container">
          <tr>
            <th>Date</th>
            <th>Order ID</th>
            <th style="flex: 1 1 auto">Items</th>
            <th>Complete</th>
            <th>Total</th>
            <th>Paid</th>
          </tr>
        </thead>
        <tbody>
          <tr class="sub-container" :key="orderKey" v-for="(order, orderKey) in $store.state.sales">
            <td>{{new Date(order.timestamp).toLocaleDateString('en-US', {})}}</td>
            <td>
              <router-link :to="`/sales/${orderKey}`">{{orderKey}}</router-link>
            </td>
            <td style=" flex: 1 1 auto;">
              <table class="sub-container inner-table">
                <thead>
                  <tr class="flex between">
                    <th>User</th>
                    <th>Item</th>
                    <th>Status</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <!-- <th>S&H</th>
                    <th>Total</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr :key="itemKey" v-for="(item, itemKey) in order.items" class="flex between align-center text-center">
                    <td>
                      <user :userid="item.buyer"></user>
                    </td>
                    <td>
                      <router-link :to="`/i/${item.type}/${item.iitemid}`" class="r8 flex wrap">
                        <b class="r4">
                          <i :class="$store.state.icons[item.type]" class="r4"></i>
                          {{item.itemTitle}}
                        </b>
                      </router-link>
                    </td>
                    <td>
                      <select 
                        @change="updateOrder(orderKey, item)"
                        v-model="item.status"
                        name="item-status"
                        id="item-status"
                      >
                        <option
                          :key="statusKey"
                          v-for="(status, statusKey) in ['new-order', 'processing', 'shipped', 'delivered', 'order-error']"
                          :value="status"
                        >{{status}}</option>
                      </select>
                    </td>
                    <td>{{item.qty}}</td>
                    <td>${{item.purchase.cost}}</td>
                    <!-- <td>{{item.purchase['shipping and handling']}}</td>
                    <td>${{(item.purchase.cost * item.qty) + item.purchase['shipping and handling']}}</td> -->
                  </tr>
                </tbody>
              </table>
            </td>
            <td>{{order.complete}}</td>
            <td>{{order.total}}</td>
            <td>{{order.paid}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <span class="sub-container">Fetching sales...</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "sales",
  methods: {
    updateOrder(orderId, item) {
      this.$store.dispatch("update", {
        // noReload: true,
        type: "orders",
        id: orderId,
        data: { orderId, item },
      });
    },
  },
  mounted() {
    this.$store.dispatch("query", {
      type: "sales",
      user: this.$store.state.auth.uid,
    }).then(()=>setTimeout(()=>this.salesin = true, 100));
  },
  data() {
    return {
      salesin: false
    }
  },
};
</script>
<style scoped>
table {
  white-space: nowrap;
  table-layout: fixed;
}
tr {
  display: flex;
  white-space: break-spaces;
  align-items: center;
}
.inner-table table {
  width: 100%;
  display: flex;
  align-items: center;
}
.inner-table tr {
  width: auto;
  display: flex;
  white-space: break-spaces;
  align-items: center;
  justify-content: space-between;
}

.inner-table td {
  flex: 1 1 auto;
  text-align: center;
}
th, td {
  white-space: break-spaces;
  flex: 0 1 auto;
  justify-self: center;
  align-items: center;
  
}
</style>